import { configureStore } from '@reduxjs/toolkit';

import {
  commonReducer,
  drawersReducer,
  layoutReducer,
  pendingActivityEventsReducer,
  routerNetworkReducer,
} from './reducers/index.js';

const store = configureStore({
  reducer: {
    drawers: drawersReducer,
    common: commonReducer,
    layout: layoutReducer,
    pendingActivityEvents: pendingActivityEventsReducer,
    routerNetwork: routerNetworkReducer,
  },
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export default store;
